import { cn } from "@/lib/utils";

interface PercentageProgressBarProps {
    text: string;
    percentage: number;
    isSelected: boolean;
}

/**
 * 투표 결과 진행바 컴포넌트
 * 선택된 옵션은 초록색, 미선택은 파란색 배경
 */
export const PercentageProgressBar: React.FC<PercentageProgressBarProps> = ({
    text,
    percentage,
    isSelected
}) => {
    return (
        <div
            className={cn(
                `relative overflow-hidden rounded-xl border-2 border-gray-200
                bg-white px-4 py-3.5 dark:border-gray-700 dark:bg-black`
            )}
        >
            <div
                className={cn(
                    `absolute left-0 top-0 h-full transition-all duration-700
                    ease-out`,
                    isSelected ? "bg-green-400" : "bg-blue-400"
                )}
                style={{ width: `${percentage}%` }}
            />

            <div className="relative flex items-center justify-between">
                <span
                    className="text-[15px] font-semibold text-black
                        dark:text-white"
                >
                    {text}
                    {isSelected && (
                        <span className="ml-1.5 text-gray-500">✓</span>
                    )}
                </span>
                <span
                    className="text-[15px] font-bold text-black dark:text-white"
                >
                    {percentage}%
                </span>
            </div>
        </div>
    );
};
